module.exports = __webpack_public_path__ + "static/media/cartPageIcon.1d4bbf99.svg";